<template>
  <section>
  <div  @click="$emit('setChatRoomInfo',chatRoom, chatRoomId,isAlreadyMember)"  class="flex rounded-xl xl:rounded-2xl overflow-hidden h-24 w-full max-w-sm relative pop-click " :class="[{'bg-purple-500 bg-gradient-to-r from-purple-600 to-purple-500' : isDarkColor},'bg-white']">
    <div class="flex-grow-0 h-24 w-24 relative bg-white">
        <img class="absolute top-1/2 left-1/2 min-h-full min-w-full transform -translate-x-1/2 -translate-y-1/2 w-full h-full" :src="chatRoom.icon" :alt="chatRoom.icon" @error="$emit('errorIcon',chatRoomId)">
        
    </div>

    <div class="p-2 flex flex-col justify-around overflow-auto" >
      <h4 class="text-md font-medium line-clamp-2" :class="titleColor"> {{chatRoom.name}} </h4>

      <div class="flex space-x-2 w-full">
        <div class="flex space-x-0.5 rounded-md p-0.5 text-xs bg-transparent" :class="bodyColor"> 
          <ion-icon class="table my-auto" name="person"></ion-icon>
          <h6 class="table my-auto" v-if="chatRoom.membersId"> {{Object.keys(chatRoom.membersId).length}} </h6>
          <h6 class="table my-auto text-xs" v-else> 0 </h6>
        </div>
        <div v-if="!isAlreadyMember" @click.stop.prevent="$emit('joinChatRoom',chatRoom.id)" class="rounded-md p-1 text-xs  text-white  pop-click  transition-colors hover:bg-pink-500 bg-pink-400 opacity-90">
          <h6>Join</h6>
        </div>
      </div>
      
      <div class="line-clamp-1 text-xs" :class="bodyColor"> 
        {{chatRoom.description}}
      </div>
    
    </div>

  </div>
  </section>
</template>

<script>
export default {
  props : {
    chatRoom : Object,
    isAlreadyMember : Boolean,
    chatRoomId : String,
    isDarkColor : {
      type : Boolean,
      default : true
    }
  },
  emits : ['joinChatRoom','errorIcon','setChatRoomInfo'],
  computed : {
    titleColor(){
      if(this.isDarkColor)return 'text-white';
      return 'text-purple-500';
    },
    bodyColor(){
      if(this.isDarkColor)return 'text-purple-200';
      return 'text-purple-400';
    }
  }
}
</script>

<style>

</style>